import React, { useEffect, useState } from 'react'
import avatar from '../../../Assets/avatar.png';
import {Form, Navbar, Button} from 'react-bootstrap';
import { AiOutlineSearch } from "react-icons/ai";
import { Container, InputGroup, Nav } from 'react-bootstrap';
import { AiOutlineBars } from "react-icons/ai"
import { IoMdNotificationsOutline } from "react-icons/io"
import "./NavBar.css";
import { signOutUser } from '../../../Pages/Auth/authServices';
import { CONNEXION_NAVIGATION, PARAMETRE_ADMIN_NAVIGATION, PROFIL_ADMIN_NAVIGATION } from '../../../Routes/NAVIGATION_PATH';
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";



function NavBar() {
  const sidebar = document.getElementsByClassName("side-bar");
  //const mmm = document.getElementsByClassName('sub-menu1');
  const lyt = document.getElementsByClassName('layout-nav-side')
  //const drpdn = document.getElementsByClassName('drpdn')

  const [show, setShow] = useState(false);


  const handleClose = () => {
    if (show === false) {
      setShow(true);
    }
    else { setShow(false); }
  }

  useEffect(() => {
    if (show === true) {
      sidebar[0].classList.add("afficher");
      lyt[0].classList.remove("bien22");
    }
    else {
      sidebar[0].classList.remove("afficher");
      lyt[0].classList.add("bien22");
    }
  })
  const navigate = useNavigate();


  return (
    <Navbar expand="lg" className="nav-bar max-hw-100 mb-5" fixed="top" >
       <Container fluid>
           <div className="px-3 py-3">
             <button className="btnContAffi" onClick={handleClose}> <AiOutlineBars className="btnAffi" /> </button>
           </div>
           <Navbar.Brand href="#home"></Navbar.Brand>
       
           <form className='plack'>
             <InputGroup className="mb-2">
               <Form.Control  placeholder="Search" type='search' aria-label='Search' className="inp1" />
               <InputGroup.Text className="">
                 <AiOutlineSearch />
               </InputGroup.Text>
             </InputGroup>
           </form>
          
           <div className='notttif'>
             <IoMdNotificationsOutline  className='apled'/>
           </div>
           <div className=''>
             <div className='applod'>
               <div className="dropdown">
                 <button className="dropbtn">
                   <img src={avatar} alt='zlogo' />
                 </button>
                 <div className="dropdown-content">
                   <Link to = {PROFIL_ADMIN_NAVIGATION}>Profile</Link>
                   <Link to = {PARAMETRE_ADMIN_NAVIGATION}>Parameter</Link>
                   <Button onClick={()=>(signOutUser(navigate))}>Deconnection</Button>
                 </div>
               </div>
             </div>
           </div>
         </Container>
    </Navbar>
  );
};

export default NavBar;
